import { Loader } from 'lucide-react'

/**
 * A spinner with "Loading", as the original site showed while a page loaded. The same one
 * shows while a page's code loads and then while its data loads, so it reads as one wait.
 */
export function LoadingState({ label }: Readonly<{ label: string }>) {
  return (
    <div
      role="status"
      aria-label={label}
      className="flex h-[300px] flex-col items-center justify-center gap-2.5 text-xl text-muted-foreground"
    >
      <Loader className="size-15 animate-spin" aria-hidden="true" />
      Loading
    </div>
  )
}
